<template>
  <div class="team">
    <div class="team1"></div>
    <div class="team2"></div>
    <div class="head">
      <div class="box">
        <p>{{ title }}</p>
      </div>
    </div>
    <div class="topuser">
      <div
        class="item"
        v-for="(item, index) in topuser"
        :key="index"
        @click="
          changeModel(item.name, item.desc1, item.desc2, item.desc3, item.title)
        "
      >
        <div
          class="cover"
          :style="{
            backgroundImage:
              hover !== index - 2
                ? `url(${item.cover})`
                : `url(${item.cover2})`,
            backgroundSize: `${item.width} ${item.height}`
          }"
          @mouseover="hover = index - 2"
          @mouseout="hover = 199"
        >
          <div class="marsk"></div>
        </div>
        <h4>{{ item.name }}</h4>
      </div>
    </div>
    <div class="wrapper">
      <div
        class="item"
        v-for="(item, index) in list"
        :key="index"
        @click="
          changeModel(item.name, item.desc1, item.desc2, item.desc3, item.title)
        "
      >
        <div
          class="cover"
          :style="{
            backgroundImage:
              hover !== index ? `url(${item.cover})` : `url(${item.cover2})`,
            backgroundSize: `${item.width} ${item.height}`
          }"
          @mouseover="hover = index"
          @mouseout="hover = 199"
        >
          <div class="marsk"></div>
        </div>
        <h4>{{ item.name }}</h4>
      </div>
      <div class="item">
        <div class="cover mydefault"></div>
        <h4>期待您的加入</h4>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { userChines, TopUser } from "@/util/text";
export default {
  data() {
    return {
      topuser: TopUser,
      hover: 100
    };
  },
  methods: {
    changeModel(name, desc1, desc2, desc3, title) {
      this.$emit("changeModel", true, name, desc1, desc2, desc3, title);
    }
  },
  computed: {
    ...mapGetters({ language: "getType" }),
    title() {
      return this.language == "中文" ? "投资团队" : "Wandering ";
    },
    list() {
      return this.language == "中文" ? userChines : userEnglis1;
    }
    // list2() {
    //   return this.language == "中文" ? userChines : userEnglis2;
    // }
  }
};
</script>

<style lang="less" scoped>
.team {
  width: 100%;
  position: relative;
  margin-top: 250px;
  .head {
    width: 100%;
    height: 315px;
    background: url("../assets/teambg.png") no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    .box {
      width: 1200px;
      margin: 0 auto;
      overflow: hidden;
      h4 {
        margin-top: 0px;
        font-size: 44px;
        color: rgba(255, 255, 255, 1);
        font-weight: normal;
      }
      p {
        font-size: 42px;
        margin-top: 40px;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
  .team1 {
    position: absolute;
    width: 293px;
    height: 788px;
    background: url("../assets/team1.png") no-repeat;
    background-size: contain;
    top: 340px;
    right: 0;
  }
  .team2 {
    position: absolute;
    width: 293px;
    height: 788px;
    background: url("../assets/team2.png") no-repeat;
    background-size: contain;
    top: 340px;
    left: 0;
  }
  .topuser {
    width: 1000px;
    display: flex;
    margin: -185px auto 0;
    justify-content: space-around;
  }
  .wrapper {
    margin: 0 auto 0;
    justify-content: space-between;
    width: 1200px;

    &:after {
      content: "";
      width: 390px;
    }
  }
  .wrapper,
  .topuser {
    display: flex;
    flex-wrap: wrap;

    .item {
      width: 390px;
      height: 555px;
      text-align: center;
      background: url("../assets/teambg1.png");
      background-size: 100% 100%;
      margin-top: 20px;
      position: relative;
      z-index: 5;
      cursor: pointer;
      .mydefault {
        width: 313px;
        height: 313px;
        background: url("../assets/default.png") no-repeat;
        background-size: contain;
      }
      .cover {
        width: 313px;
        height: 313px;
        background-size: 100% 100%;
        margin: 35px;
        position: relative;
        // &:hover {
        //   .marsk {
        //     opacity: 1;
        //     background: rgba(0, 0, 0, 0.3);
        //     transition: 0.3 all;
        //     filter: blur(10px);
        //   }
        // }

        .marsk {
          position: absolute;
          width: 100%;
          height: 100%;
          opacity: 0;
          z-index: 10;
          top: 0;
          left: 0;
        }
      }
      h4 {
        font-size: 26px;
        font-weight: 600;
        color: rgba(78, 78, 78, 1);
      }
      .desc {
        font-size: 22px;
        color: rgba(78, 78, 78, 1);
        margin-top: 5px;
      }
    }
  }
  .content {
    width: 1200px;
    position: absolute;
    top: 145px;
    left: 50%;
    margin-left: -600px;
    display: flex;
    justify-content: space-between;

    .item {
      width: 390px;
      height: 555px;
      text-align: center;
      position: relative;
      z-index: 5;
      background: url("../assets/teambg1.png");
      background-size: 100% 100%;
      cursor: pointer;
      .cover {
        width: 313px;
        height: 313px;
        background-size: 100% 100%;
        margin: 35px;
        position: relative;
        &:hover {
          .marsk {
            opacity: 1;
            background: rgba(0, 0, 0, 0.3);
            transition: 0.5 all;
            filter: blur(10px);
          }
        }
        .marsk {
          position: absolute;
          width: 100%;
          height: 100%;
          opacity: 0;
          z-index: 10;
          top: 0;
          left: 0;
        }
      }
      h4 {
        font-size: 26px;
        font-weight: 600;
        color: rgba(78, 78, 78, 1);
      }
      .desc {
        font-size: 22px;
        color: rgba(78, 78, 78, 1);
        margin-top: 5px;
      }
    }
  }
  .head {
    width: 100%;
    height: 315px;
    background: url("../assets/teambg.png") no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    .text {
      font-size: 40px;
      text-align: center;
      margin-top: 30px;
      color: rgba(255, 255, 255, 1);
      text-shadow: 3px 4px 21px rgba(0, 228, 161, 0.97);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/team.vue